/**
 * Country → Currency mapping and helpers
 */

export const COUNTRIES = [
  { code: 'India', label: 'India', currency: 'INR', symbol: '₹' },
  { code: 'UAE', label: 'UAE', currency: 'AED', symbol: 'AED ' },
  { code: 'Saudi Arabia', label: 'Saudi Arabia', currency: 'SAR', symbol: 'SAR ' },
];

export const getCurrencySymbol = (country) => {
  const c = COUNTRIES.find((ct) => ct.code === country);
  return c ? c.symbol : '₹';
};

export const getCurrencyCode = (country) => {
  const c = COUNTRIES.find((ct) => ct.code === country);
  return c ? c.currency : 'INR';
};

/**
 * Pre-fill values by country + industry
 * Format: { monthlyOrders, aov, dataCollectionPct, repeatSalesPct }
 */
const PREFILL_DATA = {
  India: {
    'Apparel & Fashion':     { monthlyOrders: 50000,   aov: 5000,   dataCollectionPct: 90, repeatSalesPct: 50 },
    'Beauty & Cosmetics':    { monthlyOrders: 10000,   aov: 5000,   dataCollectionPct: 90, repeatSalesPct: 65 },
    'Footwear':              { monthlyOrders: 20000,   aov: 7000,   dataCollectionPct: 90, repeatSalesPct: 35 },
    'Jewellery':             { monthlyOrders: 5000,    aov: 150000, dataCollectionPct: 100, repeatSalesPct: 30 },
    'Electronics':           { monthlyOrders: 10000,   aov: 15000,  dataCollectionPct: 90, repeatSalesPct: 30 },
    'Home':                  { monthlyOrders: 10000,   aov: 10000,  dataCollectionPct: 90, repeatSalesPct: 30 },
    'Food & Restaurants':    { monthlyOrders: 100000,  aov: 400,    dataCollectionPct: 60, repeatSalesPct: 60 },
    'Grocery':               { monthlyOrders: 1000000, aov: 400,    dataCollectionPct: 70, repeatSalesPct: 85 },
  },
  UAE: {
    'Apparel & Fashion':     { monthlyOrders: 25000,   aov: 600,    dataCollectionPct: 50, repeatSalesPct: 50 },
    'Beauty & Cosmetics':    { monthlyOrders: 5000,    aov: 600,    dataCollectionPct: 50, repeatSalesPct: 65 },
    'Footwear':              { monthlyOrders: 10000,   aov: 1000,   dataCollectionPct: 50, repeatSalesPct: 35 },
    'Jewellery':             { monthlyOrders: 5000,    aov: 20000,  dataCollectionPct: 100, repeatSalesPct: 30 },
    'Electronics':           { monthlyOrders: 5000,    aov: 2000,   dataCollectionPct: 50, repeatSalesPct: 30 },
    'Home':                  { monthlyOrders: 5000,    aov: 1500,   dataCollectionPct: 50, repeatSalesPct: 30 },
    'Food & Restaurants':    { monthlyOrders: 50000,   aov: 200,    dataCollectionPct: 50, repeatSalesPct: 60 },
    'Grocery':               { monthlyOrders: 1000000, aov: 1000,   dataCollectionPct: 30, repeatSalesPct: 85 },
  },
  'Saudi Arabia': {
    'Apparel & Fashion':     { monthlyOrders: 25000,   aov: 600,    dataCollectionPct: 50, repeatSalesPct: 50 },
    'Beauty & Cosmetics':    { monthlyOrders: 5000,    aov: 600,    dataCollectionPct: 50, repeatSalesPct: 65 },
    'Footwear':              { monthlyOrders: 10000,   aov: 1000,   dataCollectionPct: 50, repeatSalesPct: 35 },
    'Jewellery':             { monthlyOrders: 5000,    aov: 20000,  dataCollectionPct: 100, repeatSalesPct: 30 },
    'Electronics':           { monthlyOrders: 5000,    aov: 2000,   dataCollectionPct: 50, repeatSalesPct: 30 },
    'Home':                  { monthlyOrders: 5000,    aov: 1500,   dataCollectionPct: 50, repeatSalesPct: 30 },
    'Food & Restaurants':    { monthlyOrders: 50000,   aov: 200,    dataCollectionPct: 50, repeatSalesPct: 60 },
    'Grocery':               { monthlyOrders: 1000000, aov: 1000,   dataCollectionPct: 30, repeatSalesPct: 85 },
  },
};

export const getPrefillData = (country, industry) => {
  if (!country || !industry) return null;
  return PREFILL_DATA[country]?.[industry] || null;
};

/**
 * Get the maturity band label from a final score (0-100)
 */
export const getMaturityBand = (score) => {
  if (score <= 30) return 'Foundational';
  if (score <= 50) return 'Developing';
  if (score <= 70) return 'Capable';
  if (score <= 85) return 'Advanced';
  return 'Best-in-class';
};
